import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { restoreAll } from '../restoreAll';
import { RootState } from '..';

export interface SignInSlice {
    step: number;
    username: string;
    code: string;
}

const initialState: SignInSlice = {
    step: 0,
    username: '',
    code: '',
};

const signInSlice = createSlice({
    name: 'signIn',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        changeStep: (state, action: PayloadAction<number>) => {
            state.step = action.payload;
        },
        setUsername: (state, action: PayloadAction<string>) => {
            state.username = action.payload;
        },
        setCode: (state, action: PayloadAction<string>) => {
            state.code = action.payload;
        },
    },
});

export const { changeStep, setUsername, setCode } = signInSlice.actions;

export const selectSignIn = (state: RootState) => state.signIn;
export const selectStep = (state: RootState) => state.signIn.step;
export const selectUsername = (state: RootState) => state.signIn.username;
export const selectCode = (state: RootState) => state.signIn.code;

export default signInSlice.reducer;
